import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';
import { CollectionHeaderComponent } from './collection-header.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
    ],
    declarations: [
        CollectionHeaderComponent
    ],
    exports: [
        CollectionHeaderComponent
    ]
})
export class CollectionHeaderModule { }
